<template>
  <div class="settings">
    <template>
      <el-tabs class="settings-tabs maxW" v-model="activeName2" type="card">
        <!-- <el-tab-pane label="账号绑定" name="1">
          <account />
        </el-tab-pane> -->
        <el-tab-pane :label="$t('settings.title1')" name="2">
          <info />
        </el-tab-pane>
        <el-tab-pane :label="$t('settings.title2')" name="3">
          <password />
        </el-tab-pane>
        <!-- <el-tab-pane label="人脸采集" name="4" v-if="userRole.indexOf(4)>-1||userRole.indexOf(6)>-1">
          <collect />
        </el-tab-pane> -->
      </el-tabs>
    </template>
  </div>
</template>
<script>
// import account from './bindAccount';
import info from './baseInfo';
import password from './changePassword';
// import collect from './faceCollection';
export default {
  components: {
    // account,
     info, 
     password,
      // collect
  },
  data() {
    return {
      activeName2: '2',
      userRole: this.$store.getters.userInfo.role,

    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.settings{
  padding-top: 40px;
  background: #E9ECF3;

  .settings-tabs{
    padding: 0;
    background: #fff;

    .el-tabs__header{
      margin: 0;
    }

    .el-tabs__nav.is-top{
      border: 0 none;

      .el-tabs__item.is-top{
        color: #666666;
        border-left: 0 none;

        &.is-active{
          color: #4477C3;
          font-weight:bold;
          border-left: 1px solid #E4E7ED;
          border-right: 1px solid #E4E7ED;
        }

      }

    }

  }


  .el-tabs__nav.is-top{
    border-top: 0 none;
  }
}
</style>
